import { getSystemLogs } from '@/api/errorsUtility';

export const GET_LOGS = 'GET_LOGS';

export default {
  [GET_LOGS]: (_context, payload) => getSystemLogs(payload),
};
